<template>
  <div>
    <!-- 财务应收 -->
    <div class="infoDiv">
      <div class="h3title">财务应收</div>
      <div class="formbox">
        <el-form :model="CaiWuData" ref="CaiWuDataRef" label-width="100px" class="glo_formBox" :disabled="isPosting">
          <el-form-item label="基本运费:" prop="basicFreight">
            <div class="disFlexs jsInput">
              <el-input v-model="CaiWuData.basicFreight" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
              <!-- <el-button
                class="jsBtns glo_bgcMainColor"
                @click="getBasicFreight()"
                v-if="!isPosting"
                >计算</el-button
              >-->
            </div>
          </el-form-item>
          <el-form-item label="提货费:" prop="takeFee">
            <el-input v-model="CaiWuData.takeFee" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
          </el-form-item>
          <el-form-item label="送货费:" prop="sendFee">
            <el-input v-model="CaiWuData.sendFee" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
          </el-form-item>
          <el-form-item label="装卸费:" prop="unLoadFee">
            <el-input v-model="CaiWuData.unLoadFee" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
          </el-form-item>
          <el-form-item label="保险费:" prop="insuranceFee">
            <el-input v-model="CaiWuData.insuranceFee" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
          </el-form-item>
          <el-form-item label="其他费用:" prop="allOtherFee">
            <div class="disFlexs jsInput">
              <el-input v-model="CaiWuData.allOtherFee" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
              <el-button class="jsBtns glo_bgcMainColor" @click="getOtherExpenses()" v-if="!isPosting">计算</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="glo_Table" style="margin-bottom: 20px">
        <el-button v-if="!isPosting" class="glo_bgcMainColor" style="margin-bottom: 10px" @click="AddFeiXian">添加应收费项</el-button>
        <el-table ref="ysTable" :data="CaiWuData.itemServiceReqs" show-summary border style="width: 100%">
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <el-table-column align="center" prop="itemServiceName" label="费项"></el-table-column>
          <el-table-column align="center" prop="itemCategoryName" label="费项类型"></el-table-column>
          <el-table-column align="center" prop="amount" label="金额"></el-table-column>
          <el-table-column align="center" prop="remarks" label="备注"></el-table-column>
          <el-table-column fixed="right" label="操作" v-if="!isPosting">
            <template slot-scope="scope">
              <div class="iconList">
                <el-button class="tbBtns" @click="editFeiXian(scope.row, scope.$index)">编辑</el-button>

                <el-popconfirm title="确定删除该行数据吗" @confirm="delFeiXian(scope.$index)">
                  <el-button slot="reference" class="tbBtns">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="formbox">
        <el-form :model="CaiWuData" ref="CaiWuData" label-width="100px" class="glo_formBox" :disabled="isPosting">
          <el-form-item label="运费合计:" prop="totalFreight">
            <div class="disFlexs jsInput">
              <el-input v-model="CaiWuData.totalFreight" placeholder="请输入" clearable type="number"></el-input>
              <el-button class="jsBtns glo_bgcMainColor" @click="getTotalFreight()" v-if="!isPosting">计算</el-button>
            </div>
          </el-form-item>
          <el-form-item label="是否开票:" prop="isInvoice">
            <el-select filterable clearable v-model="CaiWuData.isInvoice" placeholder="请选择">
              <el-option v-for="(item, index) in yesOrNoList" :key="index" :label="item.name" :value="item.val + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票税点:" prop="invoiceTaxPoint">
            <div class="disFlex">
              <el-input v-model="CaiWuData.invoiceTaxPoint" placeholder="请输入" clearable type="number" @input="getTaxes()"></el-input>
              <div>(%)</div>
            </div>
          </el-form-item>
          <el-form-item label="税金:" prop="taxes">
            <div class="disFlexs jsInput">
              <el-input v-model="CaiWuData.taxes" placeholder="请输入" clearable type="number"></el-input>
              <el-button class="jsBtns glo_bgcMainColor" @click="getTaxes()" v-if="!isPosting">计算</el-button>
            </div>
          </el-form-item>
          <el-form-item label="开单金额:" prop="billingAmount">
            <div class="disFlexs jsInput">
              <el-input v-model="CaiWuData.billingAmount" placeholder="请输入" clearable type="number" min="0"></el-input>
              <el-button class="jsBtns glo_bgcMainColor" @click="getBillingAmount()" v-if="!isPosting">计算</el-button>
            </div>
          </el-form-item>
          <el-form-item label="代收货款:" prop="agentAmount">
            <el-input v-model="CaiWuData.agentAmount" placeholder="请输入" clearable type="number"></el-input>
          </el-form-item>
          <el-form-item label="结算方式:" prop="settlementMethodConfDictId">
            <el-select filterable clearable v-model="CaiWuData.settlementMethodConfDictId" placeholder="请选择" @change="changeSettlementMethod">
              <el-option v-for="(item, index) in settlementMethodList" :key="index" :label="item.val" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="寄付金额:" prop="senderAmount	">
            <el-input v-model="CaiWuData.senderAmount" placeholder="请输入" :disabled="amountIsAble" type="number"></el-input>
          </el-form-item>
          <el-form-item label="到付金额:" prop="receivedAmount">
            <el-input v-model="CaiWuData.receivedAmount" placeholder="请输入" :disabled="amountIsAble" type="number"></el-input>
          </el-form-item>
          <el-form-item label="月结金额:" prop="monthlyAmount">
            <el-input v-model="CaiWuData.monthlyAmount" placeholder="请输入" :disabled="amountIsAble" type="number"></el-input>
          </el-form-item>
          <el-form-item label="回单结金额:" prop="rnorderAmount">
            <el-input v-model="CaiWuData.rnorderAmount" placeholder="请输入" :disabled="amountIsAble" type="number"></el-input>
          </el-form-item>
          <el-form-item label="货款扣运费:" prop="goodsDeductedAmoun">
            <el-input v-model="CaiWuData.goodsDeductedAmoun" placeholder="请输入" :disabled="amountIsAble" type="number"></el-input>
          </el-form-item>

          <el-form-item class="textArea" style="width: 100%" label="费项说明:" prop="remarks">
            <el-input type="textarea" rows="2" v-model="CaiWuData.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 财务应付 -->
    <div class="infoDiv">
      <div class="h3title">财务应付</div>
      <div class="glo_Table" style="margin-bottom: 20px">
        <el-button v-if="!isPosting" class="glo_bgcMainColor" style="margin-bottom: 10px" @click="addYinFu">添加应付</el-button>
        <el-table show-summary :data="financeOutInfoReqs" border style="width: 100%">
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <el-table-column align="center" prop="itemServiceName" label="费项"></el-table-column>
          <el-table-column align="center" prop="amount" label="金额"></el-table-column>
          <el-table-column align="center" prop="objectName" label="结算对象"></el-table-column>
          <el-table-column align="center" prop="paymentMethodConfDictName" label="付款方式"></el-table-column>
          <el-table-column align="center" prop="remarks" label="备注"></el-table-column>
          <el-table-column fixed="right" prop="cccc" label="操作" v-if="!isPosting">
            <template slot-scope="scope">
              <div class="iconList">
                <el-button class="tbBtns" @click="EditFeiXian(scope.row, scope.$index)">编辑</el-button>
                <el-popconfirm title="确定删除该行数据吗" @confirm="delFeiXian2(scope.$index)">
                  <el-button slot="reference" class="tbBtns">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 弹窗 添加应收 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form class="diaForm" v-if="isShowDialog" ref="dialogFormRef" :model="dialogForm" label-width="100px" :rules="rulesForm">
          <el-form-item class="dialogFormItems" prop="itemCategoryId" label="费项类型:">
            <el-select filterable clearable v-model="dialogForm.itemCategoryId" placeholder="请选择" @change="changeItemCategoryId">
              <el-option v-for="(item, index) in categoryNameList" :key="index" :label="item.categoryName" :value="item.categoryId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="itemServiceId" label="费项:">
            <el-select filterable clearable v-model="dialogForm.itemServiceId" placeholder="请选择" @change="changeItemServiceId">
              <el-option v-for="(item, index) in CategoryServiceList" :key="index" :label="item.title" :value="item.itemServiceId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="amount" label="金额:">
            <el-input v-model="dialogForm.amount"></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 添加应付 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="diaCancelBtn2"
      @diaConfirmBtn="diaConfirmBtn2('dialogForm2Ref')"
    >
      <div class="glo_dialogForm">
        <el-form class="diaForm" ref="dialogForm2Ref" v-if="isShowDialog2" :model="dialogForm2" label-width="100px" :rules="rulesForm2">
          <el-form-item class="dialogFormItems" prop="inoutStatus" label="收支类型:">
            <el-select filterable clearable v-model="dialogForm2.inoutStatus" placeholder="请选择" disabled>
              <el-option v-for="(item, index) in inoutStatusList" :key="index" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width: 500px" class="dialogFormItems" prop="objectStatusType" label="结算对象:">
            <div class="multipleSelect">
              <el-select filterable clearable v-model="dialogForm2.objectStatusType" placeholder="请选择" @change="changeObjestStatus">
                <el-option v-for="(item, index) in objectStatusList" :key="index" :label="item.val" :value="item.key"></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectName"
                placeholder="请选择"
                remote
                :allow-create="dialogForm2.objectStatusType == 'other'"
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option v-for="(item, index) in CustomerListsYF" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
              <!-- <el-select
                filterable
                clearable
                v-model="dialogForm2.objectName"
                placeholder="请选择"
                remote
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>-->
            </div>
          </el-form-item>
          <el-form-item style="width: 500px" class="dialogFormItems" prop="itemCategoryId" label="费项:">
            <div class="multipleSelect">
              <el-select filterable clearable v-model="dialogForm2.itemCategoryId" placeholder="请选择" @change="changeItemCategoryIdYF">
                <el-option v-for="(item, index) in categoryNameList" :key="index" :label="item.categoryName" :value="item.categoryId"></el-option>
              </el-select>
              <el-select allow-create filterable clearable v-model="dialogForm2.itemServiceId" placeholder="请选择" @change="changeItemServiceId2">
                <el-option v-for="(item, index) in CategoryServiceList" :key="index" :label="item.title" :value="item.itemServiceId"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="amount" label="金额:">
            <el-input v-model="dialogForm2.amount" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="paymentMethodConfDictId" label="付款方式:">
            <el-select filterable clearable v-model="dialogForm2.paymentMethodConfDictId" placeholder="请选择" @change="changePayMent">
              <el-option v-for="(item, index) in settlementMethodList" :key="index" :label="item.val" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm2.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 最后按钮 -->
    <div class="btmBtns">
      <el-button class="saveBtns" @click="submit('0')">保存修改</el-button>
      <el-button class="glo_bgcMainColor saveBtns" @click="submit('1')">保存过账</el-button>
      <el-button class="saveBtns" @click="closePages">关闭</el-button>
    </div>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  components: {
    myDialog,
    uploadimgs,
  },
  data() {
    return {
      amountIsAble: true,
      settlementMethodList: [],
      CaiWuFeiXiang: [{ aaaa: "12" }], // 财务费项表格
      yingfuTable: [{ aaaa: "12" }], // 应付表格
      CaiWuData: { itemServiceReqs: [], delItemServiceReqs: [] },
      rules: {
        aaa: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },

      yesOrNoList: [
        {
          name: "是",
          val: "1",
        },
        {
          name: "否",
          val: "0",
        },
      ],

      // 弹窗===添加应收
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "40%",
      dialogForm: {
        // 弹窗表单数据
        aaa: "",
        bbb: "",
        ccc: "",
      },
      rulesForm: {
        itemCategoryId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        itemServiceId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        amount: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // 弹窗===添加应付
      isShowDialog2: false,
      dialogTitle2: "弹窗标题",
      diaWidth2: "40%",
      dialogForm2: {
        // 弹窗表单数据
        amount: "",
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethod: "", //付款方式名称(我自己加的)
        objectStatus: "",
      },
      rulesForm2: {
        objectStatusType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        itemCategoryId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        amount: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        paymentMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },

      CustomerList: [],
      categoryNameList: [],
      CategoryServiceList: [],
      objectStatusList: [],
      CustomerListsYF: [], //对象列表
      isPosting: false, //是否已过账

      inoutStatusList: [
        {
          name: "收入",
          val: "shou_ru:deal_status",
        },
        {
          name: "支出",
          val: "zhi_chu:deal_status",
        },
      ],

      financeOutInfoReqs: [], // 应付表格
      waybillSplitId: "",
      delItemServiceReqs2: [],
    };
  },
  watch: {
    // 监听基本运费
    "CaiWuData.basicFreight": function (a, b) {
      // 重新计算合计运费
      this.getTotalFreight();
    },
    // 监听合计运费
    "CaiWuData.totalFreight": function (a, b) {
      // 合计运费变化,重新计算税金
      this.getTaxes();
      // 合计运费变化,重新计算开单金额
      this.getBillingAmount();
    },
    // 监听税金
    "CaiWuData.taxes": function (a, b) {
      // 税金变化,重新开单金额
      this.getBillingAmount();
    },
    // 监听其他费用
    "CaiWuData.allOtherFee": function (a, b) {
      // 重新计算合计运费
      this.getTotalFreight();
    },
    // 监听开单金额变化，根据付款方式计算
    "CaiWuData.billingAmount": function (a, b) {
      // 重新计算合计运费
      this.changeSettlementMethod(this.CaiWuData.settlementMethodConfDictId);
    },
  },
  created() {},
  mounted() {
    this.getConfDictValDownList("settlement_method"); //付款方式
  },
  activated() {
    let waybillSplitId = this.$route.query.waybillSplitId || "";

    if (waybillSplitId) {
      this.waybillSplitId = waybillSplitId;
      // this.getPackageDetails(); //  获取运单详情
      this.getWaybillFinance(); // 获取运单财务信息
    }
  },
  destroyed() {},
  methods: {
    closePages() {
      this.$TOOLS.closePage();
      this.$router.push({
        path: "/WaybillManage/ComprehensiveQuery",
        query: {
          isreload: "isreload",
        },
      });
    },
    // 提交(修改)
    submit(type) {
      console.log("type", type);

      // 处理数据
      // 运单财务应收信息
      let financeInInfoReq = JSON.parse(JSON.stringify(this.CaiWuData));
      console.log("CaiWuData", financeInInfoReq);
      // 金额这些如果没有要传0
      financeInInfoReq.agentAmount = financeInInfoReq.agentAmount || 0;
      financeInInfoReq.allOtherFee = financeInInfoReq.allOtherFee || 0;
      financeInInfoReq.basicFreight = financeInInfoReq.basicFreight || 0;
      financeInInfoReq.billingAmount = financeInInfoReq.billingAmount || 0;
      financeInInfoReq.goodsDeductedAmoun =
        financeInInfoReq.goodsDeductedAmoun || 0;
      financeInInfoReq.insuranceFee = financeInInfoReq.insuranceFee || 0;
      financeInInfoReq.invoiceTaxPoint = financeInInfoReq.invoiceTaxPoint || 0;
      financeInInfoReq.isInvoice = financeInInfoReq.isInvoice || 0;
      financeInInfoReq.monthlyAmount = financeInInfoReq.monthlyAmount || 0;
      financeInInfoReq.receivedAmount = financeInInfoReq.receivedAmount || 0;
      financeInInfoReq.rnorderAmount = financeInInfoReq.rnorderAmount || 0;
      financeInInfoReq.sendFee = financeInInfoReq.sendFee || 0;
      financeInInfoReq.senderAmount = financeInInfoReq.senderAmount || 0;
      financeInInfoReq.takeFee = financeInInfoReq.takeFee || 0;
      financeInInfoReq.taxes = financeInInfoReq.taxes || 0;
      financeInInfoReq.totalFreight = financeInInfoReq.totalFreight || 0;
      financeInInfoReq.unLoadFee = financeInInfoReq.unLoadFee || 0;

      financeInInfoReq.itemServiceReqs = [
        ...financeInInfoReq.itemServiceReqs,
        ...financeInInfoReq.delItemServiceReqs,
      ];
      // delete financeInInfoReq.itemServiceVos;
      // delete financeInInfoReq.delItemServiceReqs;
      console.log("financeInInfoReq", financeInInfoReq);

      // 运单财务应付信息
      let financeOutInfoReqs = JSON.parse(
        JSON.stringify(this.financeOutInfoReqs)
      );
      financeOutInfoReqs = [...financeOutInfoReqs, ...this.delItemServiceReqs2];
      financeOutInfoReqs.forEach((item) => {
        delete item.objectStatusType;
        delete item.paymentMethodConfDictName;
        delete item.objectStatus;
        item.amount = item.amount || 0;
      });

      let param = {
        financeInInfoReq: financeInInfoReq,
        financeOutInfoReqs: financeOutInfoReqs,
        isPosting: type || 0, //type  1=过账 0=保存
        waybillSplitId: this.waybillSplitId,
      };
      if (this.isPosting) {
        delete param.financeInfoReq;
      }
      console.log("param", param);

      this.$API.wtl_postingWaybill(param).then((res) => {
        this.$message.success(res.data.message || "过账成功");
        this.closePages();
      });

      // this.$API.wtl_updateWaybill(param).then((res) => {
      //   this.$message.success(res.data.message || "修改成功");
      //   this.$TOOLS.closePage(this);
      //   this.$router.push({
      //     path: "/WaybillManage/ComprehensiveQuery",
      //   });
      // });
    },

    // 获取运单财务信息
    getWaybillFinance() {
      this.$API
        .wtl_getWaybillFinance({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || "";
          this.CaiWuData = datas.financeInInfoVo;
          this.isPosting = datas.financeInInfoVo.isPosting == 1 ? true : false;
          this.CaiWuData.itemServiceReqs = datas.financeInInfoVo.itemServiceVos;
          this.CaiWuData.itemServiceReqs.forEach((item) => {
            item.operationType = "UPDATE";
          });
          this.CaiWuData.delItemServiceReqs = [];

          this.CaiWuData.settlementMethodConfDictId =
            datas.financeInInfoVo.settlementMethodConfDictId;

          this.changeSettlementMethod(
            this.CaiWuData.settlementMethodConfDictId
          );

          // 应付
          this.financeOutInfoReqs = datas.financeOutinfoVos;
          this.financeOutInfoReqs.forEach((item) => {
            item.operationType = "UPDATE";
          });
        });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "package_name") {
            // 包装
            this.packageNameList = arrs;
            this.goodsInfoList[0].itemReqs[0].packageNameList = arrs;
          }
          if (dictType == "waybill_type") {
            // 货物类型
            this.waybillTypeList = arrs;
          }
          if (dictType == "rn_order_require") {
            // 回单类型
            this.rnrderRequireList = arrs;
          }
          if (dictType == "send_method") {
            // 获取送货方式列表
            this.sendMethodList = arrs;
          }
          if (dictType == "receive_method") {
            // 获取收货方式列表
            this.ReceivingMethodList = arrs;
          }
          if (dictType == "transport_method") {
            // 获取运输方式列表
            this.transportModeList = arrs;
          }
          if (dictType == "object_status") {
            // 获取结算对象类型
            this.objectStatusList = arrs;
          }
          if (dictType == "settlement_method") {
            // 获取付款方式
            this.settlementMethodList = arrs;
          }
        });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          if (key == "dept") {
            this.depList = arrs;
          }
          if (key == "storage") {
            this.storageList = arrs;
          }
        });
    },
    // 费型类型下拉列表
    itemCategorChoose(categoryName) {
      this.$API
        .itemCategorChoose({ categoryName: categoryName })
        .then((res) => {
          this.categoryNameList = res.data.result || [];
        });
    },
    //选择费项
    changeItemServiceId(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm.amount = item.unitPrice;
            this.dialogForm.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },
    //选择费项(应付弹窗)
    changeItemServiceId2(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm2.amount = item.unitPrice;
            this.dialogForm2.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm2.amount = "";
        this.dialogForm2.itemServiceName = "";
      }
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.dialogForm2.objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    // 选择结算对象类型
    changeObjestStatus(e) {
      this.dialogForm2.objectName = "";
      this.dialogForm2.objectNumber = "";
      this.dialogForm2.objectStatusConfDictId = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.key == e) {
            this.dialogForm2.objectStatusConfDictId = item.confDictId;
            this.dialogForm2.objectStatus = item.val;
          }
        });
        this.getObjectUserDownListYf();
      }
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogForm2.objectNumber = item.number;
            // this.dialogForm2.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },
    //选择费项类型(应付)
    changeItemCategoryIdYF(e) {
      if (e) {
        this.wtl_itemServiceListAll(e, "fu:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm2.itemCategoryName = item.categoryName;
          }
        });
      } else {
        this.dialogForm2.itemServiceId = "";
        this.dialogForm2.amount = "";
        this.dialogForm2.itemServiceName = "";
      }
    },
    //选择付款方式(应付弹窗)
    changePayMent(e) {
      if (e) {
        this.settlementMethodList.forEach((item) => {
          if (item.confDictId == e) {
            this.dialogForm2.paymentMethodConfDictName = item.val;
          }
        });
      } else {
        this.dialogForm2.amount = "";
        this.dialogForm2.itemServiceName = "";
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e, directionStatus) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          this.CategoryServiceList = res.data.result || [];
        });
    },
    //选择费项类型(应收)
    changeItemCategoryId(e) {
      if (e) {
        this.wtl_itemServiceListAll(e, "shou:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm.itemCategoryName = item.categoryName;
          }
        });
      } else {
        this.dialogForm.itemServiceId = "";
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },
    // 选择结算方式
    changeSettlementMethod(e) {
      let val = "";
      this.settlementMethodList.forEach((item) => {
        if (item.confDictId == e) {
          val = item.key;
        }
      });
      this.amountIsAble = true;
      if (val == "ji_fu_xian_jie") {
        //寄付现结
        this.CaiWuData.senderAmount = this.CaiWuData.billingAmount || 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "dao_fu") {
        //到付
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = this.CaiWuData.billingAmount || 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "ji_fu_yue_jie") {
        //寄付月结
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = this.CaiWuData.billingAmount || 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "ji_fu_hui_dan_jie") {
        //寄付回单结
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = this.CaiWuData.billingAmount || 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "duo_bi_fu") {
        //多笔付
        this.amountIsAble = false;

        // this.CaiWuData.senderAmount = 0; //寄付
        // this.CaiWuData.receivedAmount = 0; //到付
        // this.CaiWuData.monthlyAmount = 0; //月结
        // this.CaiWuData.rnorderAmount = 0; //回单结
        // this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "dai_shou_huo_kuan_kou") {
        //代收货款扣
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = this.CaiWuData.billingAmount || 0; //货款扣运费
      } else if (val == "mian_fei") {
        //免费
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      }
      // if (e == 6) {
      //   //寄付现结
      //   this.CaiWuData.senderAmount = this.CaiWuData.billingAmount || 0; //寄付
      //   this.CaiWuData.receivedAmount = 0; //到付
      //   this.CaiWuData.monthlyAmount = 0; //月结
      //   this.CaiWuData.rnorderAmount = 0; //回单结
      //   this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      // } else if (e == 58) {
      //   //到付
      //   this.CaiWuData.senderAmount = 0; //寄付
      //   this.CaiWuData.receivedAmount = this.CaiWuData.billingAmount || 0; //到付
      //   this.CaiWuData.monthlyAmount = 0; //月结
      //   this.CaiWuData.rnorderAmount = 0; //回单结
      //   this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      // } else if (e == 59) {
      //   //寄付月结
      //   this.CaiWuData.senderAmount = 0; //寄付
      //   this.CaiWuData.receivedAmount = 0; //到付
      //   this.CaiWuData.monthlyAmount = this.CaiWuData.billingAmount || 0; //月结
      //   this.CaiWuData.rnorderAmount = 0; //回单结
      //   this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      // } else if (e == 60) {
      //   //寄付回单结
      //   this.CaiWuData.senderAmount = 0; //寄付
      //   this.CaiWuData.receivedAmount = 0; //到付
      //   this.CaiWuData.monthlyAmount = 0; //月结
      //   this.CaiWuData.rnorderAmount = this.CaiWuData.billingAmount || 0; //回单结
      //   this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      // } else if (e == 61) {
      //   //多笔付
      //   this.amountIsAble = false;
      //   this.CaiWuData.senderAmount = 0; //寄付
      //   this.CaiWuData.receivedAmount = 0; //到付
      //   this.CaiWuData.monthlyAmount = 0; //月结
      //   this.CaiWuData.rnorderAmount = 0; //回单结
      //   this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      // } else if (e == 62) {
      //   //代收货款扣
      //   this.CaiWuData.senderAmount = 0; //寄付
      //   this.CaiWuData.receivedAmount = 0; //到付
      //   this.CaiWuData.monthlyAmount = 0; //月结
      //   this.CaiWuData.rnorderAmount = 0; //回单结
      //   this.CaiWuData.goodsDeductedAmoun = this.CaiWuData.billingAmount || 0; //货款扣运费
      // } else if (e == 64) {
      //   //免费
      //   this.CaiWuData.senderAmount = 0; //寄付
      //   this.CaiWuData.receivedAmount = 0; //到付
      //   this.CaiWuData.monthlyAmount = 0; //月结
      //   this.CaiWuData.rnorderAmount = 0; //回单结
      //   this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      // }
    },
    // 税金
    getTaxes() {
      let num1 = this.CaiWuData.totalFreight || 0; //运费合计
      let num2 = this.CaiWuData.invoiceTaxPoint || 0; //税点
      let num3 = this.$TOOLS.divide(num2, 100);
      this.CaiWuData.taxes = this.$TOOLS.mul(num1, num3).toFixed(2);
    },
    // 计算:其他费用
    getOtherExpenses(arr) {
      let array = [];
      if (arr) {
        array = arr;
      } else {
        // 动态计算其他费用
        this.CaiWuData.itemServiceReqs.forEach((item) => {
          array.push(item.amount);
        });
      }

      this.CaiWuData.allOtherFee = this.$TOOLS.getAddMathNumber(array);
    },
    // 计算:开单金额
    getBillingAmount() {
      let num1 = this.CaiWuData.totalFreight || 0; //运费合计
      let num2 = this.CaiWuData.taxes || 0; //税金
      let array = [num1, num2];
      this.CaiWuData.billingAmount = this.$TOOLS.getAddMathNumber(array);
    },
    // 计算:运费合计
    getTotalFreight() {
      let num1 = this.CaiWuData.basicFreight || 0; //基本运费
      let num2 = this.CaiWuData.takeFee || 0; //提货费
      let num3 = this.CaiWuData.sendFee || 0; //送货费
      let num4 = this.CaiWuData.unLoadFee || 0; //装卸费
      let num5 = this.CaiWuData.insuranceFee || 0; //保险费
      let num6 = this.CaiWuData.allOtherFee || 0; //其他费用
      let array = [num1, num2, num3, num4, num5, num6];

      this.CaiWuData.totalFreight = this.$TOOLS.getAddMathNumber(array);
    },
    // 添加应付弹窗
    addYinFu() {
      this.isShowDialog2 = true;
      this.dialogTitle2 = "新建应付";
      this.dialogType2 = "add";
      this.dialogForm2.inoutStatus = "zhi_chu:deal_status";
      this.itemCategorChoose(); //费型类型下拉列表
      this.getConfDictValDownList("object_status"); //结算对象类型
    },
    // 添加一应收费项
    AddFeiXian() {
      this.isShowDialog = true;
      this.dialogTitle = "新建应收费项";
      this.dialogType = "add";
      this.itemCategorChoose(); //费型类型下拉列表
    },
    editFeiXian(row, deitIdx) {
      this.isShowDialog = true;
      this.dialogTitle = "编辑应收费项";
      this.dialogType = "edit";
      this.deitIdx = deitIdx;
      this.dialogForm = JSON.parse(JSON.stringify(row));

      this.itemCategorChoose(); //费型类型下拉列表
    },
    // 删除一行应收费项
    delFeiXian(idx2) {
      console.log("idx2", idx2);
      let datas = JSON.parse(
        JSON.stringify(this.CaiWuData.itemServiceReqs[idx2])
      );
      if (datas.operationType !== "ADD") {
        datas.operationType = "DEL";
        this.CaiWuData.delItemServiceReqs.push(datas);
        console.log(
          "this.CaiWuData.delItemServiceReqs",
          this.CaiWuData.delItemServiceReqs
        );
      }

      this.CaiWuData.itemServiceReqs.splice(idx2, 1);
      this.getOtherExpenses();
    },
    EditFeiXian(row, idx) {
      console.log("row", row);
      // // this.isShowDialog2 = true;
      // this.dialogTitle2 = "编辑应付";
      // this.dialogType2 = "edit";
      // this.editYfIdx = idx;

      // this.dialogForm2 = JSON.parse(JSON.stringify(row)); //如果不转表格跟弹窗的数据会一起变
      // this.itemCategorChoose(); //费型类型下拉列表
      // this.getConfDictValDownList("object_status"); //结算对象类型
      // this.getObjectUserDownListYf(); //获取结算对象
      // this.wtl_itemServiceListAll(
      //   this.dialogForm2.itemCategoryId,
      //   "fu:direction_status"
      // ); //获取费项(应收)
      // this.dialogForm2.inoutStatus = "zhi_chu:deal_status";

      this.dialogTitle2 = "编辑应付";
      this.dialogType2 = "edit";
      this.editYfIdx = idx;
      let datas = JSON.parse(JSON.stringify(row));

      // let inoutStatus = this.dialogForm2.inoutStatus;
      this.dialogForm2 = datas; //如果不转表格跟弹窗的数据会一起变
      this.dialogForm2.inoutStatus = "zhi_chu:deal_status";
      this.dialogForm2.objectStatusType = "";
      this.itemCategorChoose(); //费型类型下拉列表
      this.wtl_itemServiceListAll(
        this.dialogForm2.itemCategoryId,
        "fu:direction_status"
      ); //获取费项(应收)

      this.$API
        .wtl_getConfDictValDownList({ dictType: "object_status" })
        .then((res) => {
          let arrs = res.data.result || [];
          // 获取结算对象类型
          this.objectStatusList = arrs;
          this.objectStatusList.forEach((item) => {
            if (item.val == this.dialogForm2.objectStatus) {
              this.dialogForm2.objectStatusType = item.key;
              this.getObjectUserDownListYf(); //获取结算对象
            }
          });
          this.isShowDialog2 = true;
        });
    },
    // 删除一行应付费项
    delFeiXian2(idx2) {
      if (this.financeOutInfoReqs[idx2].operationType !== "ADD") {
        this.financeOutInfoReqs[idx2].operationType = "DEL";
        this.delItemServiceReqs2.push(this.financeOutInfoReqs[idx2]);
      }

      this.financeOutInfoReqs.splice(idx2, 1);
    },

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        amount: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        remarks: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      // 添加费项
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.dialogForm));
          let items = {
            amount: datas.amount,
            itemCategoryId: datas.itemCategoryId,
            itemCategoryName: datas.itemCategoryName,
            itemServiceId: datas.itemServiceId,
            itemServiceName: datas.itemServiceName,
            remarks: datas.remarks,
          };
          if (this.dialogType == "add") {
            // 判断是否存在
            let flag = false;
            this.CaiWuData.itemServiceReqs.forEach((item) => {
              if (item.itemServiceId == items.itemServiceId) {
                flag = true;
              }
            });

            if (flag) {
              this.$message.warning("该费项已存在");
              return false;
            } else {
              items.operationType = "ADD";
              this.CaiWuData.itemServiceReqs.push(items);

              this.$message.success("添加成功");
            }
          } else {
            //编辑
            let arrs = JSON.parse(
              JSON.stringify(this.CaiWuData.itemServiceReqs)
            );
            // this.CaiWuData.itemServiceReqs.forEach((item, index) => {});
            items.operationType = "UPDATE";
            arrs[this.deitIdx] = items;
            this.CaiWuData.itemServiceReqs = arrs;
          }

          // 动态计算其他费用
          let arrs = [];
          this.CaiWuData.itemServiceReqs.forEach((item) => {
            arrs.push(item.amount);
          });
          this.getOtherExpenses(arrs);
          this.isShowDialog = false;
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    /***
     * 应付
     */
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        // 弹窗表单数据
        amount: "",
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethodConfDictName: "", //付款方式名称(我自己加的)
        objectStatus: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let objs = JSON.parse(JSON.stringify(this.dialogForm2));
          if (this.dialogType2 == "add") {
            objs.operationType = "ADD";
            this.financeOutInfoReqs.push(objs);
            this.isShowDialog2 = false;
          } else {
            // editYfIdx
            let arrs = JSON.parse(JSON.stringify(this.financeOutInfoReqs));
            // objs.operationType = "UPDATE";
            arrs[this.editYfIdx] = objs;
            this.financeOutInfoReqs = arrs;
            this.isShowDialog2 = false;
          }
          console.log(this.financeOutInfoReqs);
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    /***
     * ====== 弹窗组件方法 ======
     */
  },
};
</script>
<style scoped lang='less'>
// 查询条件边框线
@borderColor: #cccccc;

.contentBox {
  padding-bottom: 50px;
}

.infoDiv {
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .formbox {
    padding: 0 30px;

    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  }

  .goodsItmes {
    margin-top: 30px;
    border-bottom: 4px solid #ccc;
    padding-bottom: 20px;
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .miniInput {
    width: 80px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-right: 2px;

    text-align: center;

    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0 5px;
    }
  }
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectAddress {
  border: 1px solid #ccc;
  margin-right: 10px;
  width: 180px !important;
}
.addressDetails {
  //   width: 380px !important;
  flex: 1;
}

.btmBtns {
  text-align: center;
  // margin: 50px auto;
  padding: 0 auto 50px;

  .saveBtns {
    font-size: 16px;
    margin: 20px;
  }
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.addTiHuoDiZhi {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}
</style>